import { LOCAL_API_URL,http } from "../base"


export async function postBaseinfo(formData) {
  for (let [key, value] of formData.entries()) {
    console.log(key, value);
  }
    try {
        const response = await http.post(
            `${LOCAL_API_URL}/employees/save_baseinfo`,
        formData,


    )
    return response
    } catch (error) {
        return error
    }

//    testSimpleUpload();

}


